import components from '../concept/data'
import { generateDeviceDataKey } from '../ReusableComponents/ByteTransfer/utils'
import renderCompImg from '../../source/Comp_Img'
import DefaultPortConnections from '../Assembly/PortConnections'

const PROJECT_ID = 'talking-dragon'

const INTERNAL_ACCESSORY_MAP = {
    'ir sensor': { isIr: true },
    ir: { isIr: true },
    'internal mic': { isMic: true },
    mic: { isMic: true },
    'temperature sensor': { isTemperature: true },
    temperature: { isTemperature: true },
    battery: { isBattery: true },
    accelerometer: { isAccelerometer: true },
    'touch 0': { isTouchZero: true },
    'touch 1': { isTouchOne: true },
    'touch 2': { isTouchTwo: true },
    'touch 3': { isTouchThree: true },
}

const normalizeName = (value) => String(value || '').trim().toLowerCase()

const getDefaultInternalAccessories = () => ({
    Four_in_one_sensor: {
        isDistanceSensors: false,
        isGestureSensor: false,
        isLightSensor: false,
        isColorSensor: false,
    },
    isFour_in_one_sensor: false,

    // input
    isTouchZero: false,
    isTouchOne: false,
    isTouchTwo: false,
    isTouchThree: false,
    // output
    isTouchZeroOutput: false,
    isTouchOneOutput: false,
    isTouchTwoOutput: false,
    isTouchThreeOutput: false,

    isMic: false,
    isTemperature: false,
    isBattery: false,
    isAccelerometer: false,

    isLeftEye: false,
    isRightEye: false,
    isEYES: false,
    isbuzzer: false,

    isSmileOne: false,
    isSmileTwo: false,
    isSmileThree: false,
    isSmileFour: false,

    // humanoid
    isUltrasonic: false,
    isGyroX: false,
    isGyroY: false,
    isGyroZ: false,
    isAccelerometerX: false,
    isAccelerometerY: false,
    isAccelerometerZ: false,
    // output
    isLeftRGB: false,
    isRightRGB: false,
    isMp3: false,
    isHeadServo: false,
    isIndivdualServo: false,
    isActionGroup: false,
    isM1: false,
    isM2: false,
    isSimpleServo: false,

    isAtrMotor1: false,
    isAtrMotor2: false,
    isAtrMotor3: false,

    // klaw
    isPot1: false,
    isPot2: false,
    isPot3: false,
    isPot4: false,
    isPot5: false,
    isPot6: false,
    isIr: false,
})

const getDeviceComponents = () => {
    // Resolve the catalog for the active board so the sidebar / componentProps
    // surface the right components (e.g. Poki's IMU, Color sensor, OLED) instead
    // of always using TOKI. Falls back to allowedDevice (admin/preview flow may not
    // set connectedDevice) and finally to TOKI1.
    const connectedDevice =
        sessionStorage.getItem('connectedDevice') ||
        sessionStorage.getItem('allowedDevice') ||
        'Toki'
    const deviceVersion = sessionStorage.getItem('deviceVersion') || '1'

    let deviceKey
    try {
        deviceKey = generateDeviceDataKey(connectedDevice, deviceVersion)
    } catch (error) {
        deviceKey = null
    }

    return components[deviceKey] || components.TOKI1 || []
}

const buildInternalAccessories = (list, baseInternalAccessories) => {
    const defaultAccessories = getDefaultInternalAccessories()
    const internalAccessories = {
        ...defaultAccessories,  // Always start with all defaults
        ...baseInternalAccessories,  // Override with any existing values
        Four_in_one_sensor: {
            ...defaultAccessories.Four_in_one_sensor,
            ...(baseInternalAccessories.Four_in_one_sensor || {}),
        },
    }

    console.log('Internal accessories before processing list:', internalAccessories)

    list.forEach((name) => {
        const normalized = normalizeName(name)
        // console.log('Found an internal accessory from API:', name, 'normalized as', normalized)
        const flags = INTERNAL_ACCESSORY_MAP[normalized]
        console.log('Mapped to flags:', flags)
        if (!flags) {
            return
        }

        Object.entries(flags).forEach(([flag, enabled]) => {
            if (flag in internalAccessories) {
                internalAccessories[flag] = enabled
            } else if (flag in internalAccessories.Four_in_one_sensor) {
                internalAccessories.Four_in_one_sensor[flag] = enabled
            }
        })
    })

    console.log('Built internal accessories:', internalAccessories)
    return internalAccessories
}

const buildExternalAccessories = (list) => {
    // console.log('Building external accessories from list:', list)
    const deviceComponents = getDeviceComponents()
    const targetNames = new Set(list.map((name) => normalizeName(name)))
    console.log('targetNames', targetNames)

    return deviceComponents
        .filter((component) =>
            targetNames.has(normalizeName(component.name)) ||
            targetNames.has(normalizeName(component.type))
        )
        .map((component) => ({
            ...component,
            selected: true,
            name: component.type.replace(/_/g, ' ').toUpperCase(),
            url: renderCompImg(component.type),
        }))
}

const buildComponentProps = (externalAccessories) => {
    const deviceComponents = getDeviceComponents()
    const componentProps = {}

    // Add ALL device components to componentProps (keyed by type)
    // with selected=false, url, and uppercase name by default
    deviceComponents.forEach((component) => {
        componentProps[component.type] = {
            ...component,
            selected: false,
            name: component.type.replace(/_/g, ' ').toUpperCase(),
            url: renderCompImg(component.type),
        }
    })

    // Mark selected ones as selected=true
    externalAccessories.forEach((component) => {
        if (componentProps[component.type]) {
            componentProps[component.type].selected = true
        }
    })

    return componentProps
}

const updateSessionStorageAccessories = ({
    internalAccessories,
    externalAccessories,
}) => {
    const currentConcept = sessionStorage.getItem('concept')
    const concept = currentConcept ? JSON.parse(currentConcept) : null

    const nextConcept = concept && typeof concept === 'object'
        ? { ...concept }
        : {
              counter: [],
              componentProps: {},
              Index: [],
              internalaccessories: getDefaultInternalAccessories(),
              disableAfterSettingByt: false,
              zingMp3List: [],
          }

    const baseInternal = nextConcept.internalaccessories ||
        getDefaultInternalAccessories()

    nextConcept.internalaccessories = buildInternalAccessories(
        internalAccessories,
        baseInternal
    )
    nextConcept.counter = externalAccessories
    nextConcept.componentProps = buildComponentProps(externalAccessories)

    sessionStorage.setItem('SelectedComp', JSON.stringify(externalAccessories))
    sessionStorage.setItem('concept', JSON.stringify(nextConcept))
    console.log('Updated sessionStorage concept with accessories:', nextConcept)
}

const buildPortConnectionsFromSteps = (steps) => {
    // Start with a copy of the default PortConnections (all null)
    const portConnections = { ...DefaultPortConnections }
    // Reset all to null
    Object.keys(portConnections).forEach((key) => {
        portConnections[key] = null
    })

    if (!Array.isArray(steps)) return portConnections

    const connectedDevice = sessionStorage.getItem('connectedDevice')
    const isTokiFamily = ['Toki', 'Poki'].includes(connectedDevice)

    steps.forEach((step, index) => {
        const { component: componentType, port } = step
        if (!componentType || !port) return

        portConnections[port] = { type: componentType, index: 0 }

        // Mirror multi-port logic from AssemblyTwo.applyPortConnection
        if (!isTokiFamily && port === 'M1') {
            portConnections['M2'] = { type: componentType, index: 0 }
        }
        if (!isTokiFamily && port === 'M3') {
            portConnections['M4'] = { type: componentType, index: 0 }
        }
    })

    console.log('Built PortConnections from steps:', portConnections)
    return portConnections
}

const buildWorkspaceComponents = (steps) => {
    const workspaceComponents = {}
    if (!Array.isArray(steps)) return workspaceComponents

    steps.forEach((step) => {
        const { component: componentType, port } = step
        if (!componentType || !port) return

        if (!workspaceComponents[componentType]) {
            workspaceComponents[componentType] = []
        }
        workspaceComponents[componentType].push({
            left: 100,
            top: 100,
            connectedTo: port,
        })
    })

    return workspaceComponents
}

const updateAssemblyTwoSessionStorage = (steps) => {
    let assemblyTwo
    try {
        assemblyTwo = JSON.parse(sessionStorage.getItem('assemblyTwo'))
    } catch (e) {
        assemblyTwo = null
    }

    if (!assemblyTwo || typeof assemblyTwo !== 'object') {
        assemblyTwo = {
            components: getDeviceComponents(),
            PortConnections: { ...DefaultPortConnections },
            workspace: {
                bibox: { top: 208, left: 328 },
                components: {},
                offset: { top: 0, left: 0 },
                scale: 1,
            },
            height: document.body.clientHeight,
            width: document.body.clientWidth,
        }
    }

    assemblyTwo.PortConnections = buildPortConnectionsFromSteps(steps)
    assemblyTwo.workspace = {
        ...assemblyTwo.workspace,
        components: buildWorkspaceComponents(steps),
    }

    sessionStorage.setItem('assemblyTwo', JSON.stringify(assemblyTwo))
    console.log('Updated assemblyTwo sessionStorage:', assemblyTwo)
}

export const processAssemblyAccessoriesFromData = (data) => {
    const internalAccessories = Array.isArray(data.internalAccessories)
        ? data.internalAccessories
        : []
    const externalAccessories = Array.isArray(data.externalAccessories)
        ? data.externalAccessories
        : []
    const steps = Array.isArray(data.steps) ? data.steps : []

    const selectedExternal = buildExternalAccessories(externalAccessories)
    updateSessionStorageAccessories({
        internalAccessories,
        externalAccessories: selectedExternal,
    })

    console.log("Assembly steps from Data:", steps)

    updateAssemblyTwoSessionStorage(steps)
    return data
}

// ADD screenId as the third parameter here
export const fetchAssemblyAccessories = async (apiProjectId, isPreview, screenId) => {
    const BACKEND_URL = process.env.REACT_APP_API_BASE || ''

    // Build the endpoint dynamically using the passed arguments
    let endpoint = isPreview 
        ? `${BACKEND_URL}/api/staging/assembly/${apiProjectId}`
        : `${BACKEND_URL}/api/assembly/${apiProjectId}`;

    // Append the screenId if it exists!
    if (screenId) {
        endpoint += `/${screenId}`
    }

    const response = isPreview 
        ? await fetch(endpoint, { credentials: 'include' }) 
        : await fetch(endpoint)

    if (!response.ok) {
        throw new Error(`Assembly request failed: ${response.status}`)
    }

    const data = await response.json()
    const internalAccessories = Array.isArray(data.internalAccessories)
        ? data.internalAccessories
        : []
    const externalAccessories = Array.isArray(data.externalAccessories)
        ? data.externalAccessories
        : []
    const steps = Array.isArray(data.steps) ? data.steps : []

    const selectedExternal = buildExternalAccessories(externalAccessories)
    console.log('selectedExternal', selectedExternal)
    console.log('internalAccessories', internalAccessories)
    updateSessionStorageAccessories({
        internalAccessories,
        externalAccessories: selectedExternal,
    })

    // Build PortConnections from steps and update assemblyTwo sessionStorage
    updateAssemblyTwoSessionStorage(steps)

    return data
}

export default fetchAssemblyAccessories
